<script>
export default {
  data() {
    return {
      isLoadingTrend:false,
      isBtnDownloadDisabled_trend:false,
      currentTaskId:"",
      eventBaseInfo: {},
      groupList:[],
      //<词云分析>模块数据
      wordCloudData: [],
      //正在加载<情感分布空心饼图数据>
      isLoadingEmotionsDistribution: true,
      //<情感分布>模块数据
      emotionsDistrubutionData: [],
      sensitiveTrendData:[],
      sensitiveTrendLabels:[],
      //记录每一个图表的dataUrl
      echartsDataUrl: {
        url_trend_all: "", //舆情走势--全部
        url_trend_source: "", //舆情走势--来源分类
        url_trend_emotions: "", //舆情走势--情感分类
        url_wordCloud: "", //词云分析
        url_emotions: "" //情感分布
      },
      columnGroup:[
        {
          title:"群组",
          key:"groupName"
        },
        {
          title:"敏感消息量",
          key:"sensitiveCount"
        },
        {
          title:"总消息量",
          key:"msgCount"
        },
        {
          title:"敏感比例",
          key:"rate"
        },
      ],
      userList:[],
      columnUser:[
        {
          title:"发言人",
          key:"sendMsgName"
        },
        {
          title:"参与群组",
          key:"groupCount"
        },
        {
          title:"总发言",
          key:"msgCount"
        },
        {
          title:"敏感消息量",
          key:"sensitiveCount"
        },
      ],
      //<舆情走势>模块数据
      sentimentTrendData: {
        xData: [],
        charts_all: [],
        charts_source: {
          data_legend: [],
          data_y: []
        },
        charts_emotion: {
          data_legend: ["正面", "负面", "中性"],
          data_y: [
            {
              name: "正面",
              type: "line",
              data: [],
              smooth: true,
              itemStyle: {
                normal: {
                  color: "#44C58D",
                  lineStyle: {
                    color: "#44C58D"
                  }
                }
              }
            },
            {
              name: "负面",
              type: "line",
              data: [],
              smooth: true,
              itemStyle: {
                normal: {
                  color: "#FA5D5D",
                  lineStyle: {
                    color: "#FA5D5D"
                  }
                }
              }
            },
            {
              name: "中性",
              type: "line",
              data: [],
              smooth: true,
              itemStyle: {
                normal: {
                  color: "#FFA810",
                  lineStyle: {
                    color: "#FFA810"
                  }
                }
              }
            }
          ]
        }
      },
      //<舆情走势>tab按钮切换
      btnTrendIsActive: {
        all: true,
        source: false,
        emotions: false
      },
      focusMsgList: [],
      accessMsgList: [],
      accessStartDate: ""
    }
  },
  mounted() {
    this.currentTaskId = this.$route.query.id;
    this.getEventBaseInfo();
    this.getTrendInfo();
    this.getEmotionsDistributionInfo();
    this.getSensitiveTrend();
    this.getWordCloudInfo();
    this.getGroupList();
    this.getFocusMsgList();
  },
  methods: {
    cancelFollowSender(index, id) {
      this.$ajax({
         method: "get",
         url: "/focusOn/cancelFocus",
         params: {
          "id": id,
          "type": 4
         }
      })
      .then(res => {
        if (res.data.success) {
          if (res.data.data) {
            this.$Message.success("取消关注成功")
          } else {
            this.$Message.error("取消关注失败")
          }
        }
      })
      .catch(err => {
        this.$Message.error("服务器错误");
        console.log(err);
      });

      if(this.focusMsgList[index].senderFollwoed){
        this.focusMsgList[index].senderFollwoed = false;
      }
      else{
        this.focusMsgList[index].senderFollwoed = true;
      }
      this.$set(this.focusMsgList, index, this.focusMsgList[index])
      console.log(index,this.focusMsgList[index],this.focusMsgList[index].senderFollwoed);

    },
    followSender(index, id) {
      this.$ajax({
        method: "get",
        url: "/focusOn/setFocus",
        params: {
          "id": id,
          "type": 4
        }
      })
      .then(res => {
        if (res.data.success) {
          if (res.data.data) {
            this.$Message.success("关注成功")
          } else {
            this.$Message.error("关注失败")
          }
        }
      })
      .catch(err => {
        this.$Message.error("服务器错误");
        console.log(err);
      });

      if(this.focusMsgList[index].senderFollwoed){
        this.focusMsgList[index].senderFollwoed = false;
      }
      else{
        this.focusMsgList[index].senderFollwoed = true;
      }
      this.$set(this.focusMsgList, index, this.focusMsgList[index])
      console.log(index,this.focusMsgList[index],this.focusMsgList[index].senderFollwoed);

    },
    cancelFollowQun(index, id) {
      this.$ajax({
        method: "get",
         url: "/focusOn/cancelFocus",
         params: {
          "id": id,
          "type": 7
         }
      })
      .then(res => {
        if (res.data.success) {
          if (res.data.data) {
            this.$Message.success("取消关注成功")
          } else {
            this.$Message.error("取消关注失败")
          }
        }
      })
      .catch(err => {
        this.$Message.error("服务器错误");
        console.log(err);
      });

      if(this.focusMsgList[index].groupFollowed){
        this.focusMsgList[index].groupFollowed = false;
      }
      else{
        this.focusMsgList[index].groupFollowed = true;
      }
      this.$set(this.focusMsgList, index, this.focusMsgList[index])
      console.log(index,this.focusMsgList[index],this.focusMsgList[index].groupFollowed);

    },

    followQun(index, id) {
      this.$ajax({
        method: "get",
        url: "/focusOn/setFocus",
        params: {
          "id": id,
          "type": 7
        }
      })
      .then(res => {
        if (res.data.success) {
          if (res.data.data) {
            this.$Message.success("关注成功")
          } else {
            this.$Message.error("关注失败")
          }
        }
      })
      .catch(err => {
        this.$Message.error("服务器错误");
        console.log(err);
      });

      if(this.focusMsgList[index].groupFollowed){
        this.focusMsgList[index].groupFollowed = false;
      }
      else{
        this.focusMsgList[index].groupFollowed = true;
      }
      this.$set(this.focusMsgList, index, this.focusMsgList[index])
      console.log(index,this.focusMsgList[index],this.focusMsgList[index].groupFollowed);

    },
    //切换<舆情走势>的tab按钮
    handleSelectBtnTrend(params) {
      this.btnTrendIsActive.all = this.btnTrendIsActive.source = this.btnTrendIsActive.emotions = false;
      this.btnTrendIsActive[params] = true;
      if (params === "all") {
        this.generateCharts_line_all();
      } else if (params === "source") {
        this.generateCharts_line_source();
      } else if (params === "emotions") {
        this.generateCharts_line_emotions();
      }
    },
    //获取舆情走势的数据
    getTrendInfo() {
      if (this.isLoadingTrend) return;
      this.isLoadingTrend = true;
      this.$ajax({
        method: "get",
        url: "./highlightEvent/eventTrend",
        params: {
          id: this.currentTaskId,
        }
      })
          .then(res => {
            this.isLoadingTrend = false;
            if (res.data.success) {
              let resData = res.data.data;
              this.sentimentTrendData.xData = [...resData.dateList];
              //更新<全部>折线图数据
              this.sentimentTrendData.charts_all = [...resData.totalTrends];
              //生成<全部>折线图
              this.generateCharts_line_all();

              //更新<来源分类>折线图数据
              //先清空
              this.sentimentTrendData.charts_source.data_legend = [];
              this.sentimentTrendData.charts_source.data_y = [];
              for (let prop in resData.sourceTrends) {
                this.sentimentTrendData.charts_source.data_legend.push(prop);
                this.sentimentTrendData.charts_source.data_y.push({
                  name: prop,
                  type: "line",
                  data: [...resData.sourceTrends[prop]],
                  smooth: true
                });
              }
              //生成<来源分类>折线图
              this.generateCharts_line_source();
              //更新<情感分类>折线图数据
              //先清空
              this.sentimentTrendData.charts_emotion.data_legend = [];
              this.sentimentTrendData.charts_emotion.data_y = [];
              for (let prop in resData.emotionTrends) {
                this.sentimentTrendData.charts_emotion.data_legend.push(prop);
                let item = {
                  name: prop,
                  type: "line",
                  smooth: true,
                  itemStyle: {
                    normal: {
                      color: (function(prop) {
                        let color = "#44C58D";
                        switch (prop) {
                          case "正面":
                            color = "#44C58D";
                            break;
                          case "负面":
                            color = "#FA5D5D";
                            break;
                          case "中性":
                            color = "#FFA810";
                            break;
                          default:
                            break;
                        }
                        return color;
                      })(prop),
                      lineStyle: {
                        color: (function(prop) {
                          let color = "#44C58D";
                          switch (prop) {
                            case "正面":
                              color = "#44C58D";
                              break;
                            case "负面":
                              color = "#FA5D5D";
                              break;
                            case "中性":
                              color = "#FFA810";
                              break;
                            default:
                              break;
                          }
                          return color;
                        })(prop)
                      }
                    }
                  },
                  data: [...resData.emotionTrends[prop]]
                };
                this.sentimentTrendData.charts_emotion.data_y.push(item);
              }
              //生成<情感分类>折线图
              this.generateCharts_line_emotions();
            } else {
              if (res.data.code !== 405) {
                this.$Message.error("服务器错误");
              }
            }
          })
          .catch(err => {
            this.$Message.error("服务器错误");
            console.log(err);
          });
    },
    //生成折线图--全部
    generateCharts_line_all() {
      this.isBtnDownloadDisabled_trend = true;
      let myChart = this.echarts.init(this.$refs.charts_line_total);
      let option = {
        xAxis: {
          type: "category",
          data: this.sentimentTrendData.xData, //x轴数据
          // max:'dataMax',

          axisLabel:{
            showMinLagel:true,
            showMaxLabel: true,
            rotate: 45,
            interval: parseInt(this.sentimentTrendData.xData.length / 10)
          },
          axisTick:{
            alignWithLabel: true
          }
          // splitLine:{
          //   interval: 0
          // }
        },
        yAxis: {
          type: "value"
        },
        title:{
          text:'舆情走势',
          textStyle:{
            fontWeight: 'normal',
            fontSize: 15
          }
        },
        grid: {
          top: "8%",
          left: "8%",
          right: "8%",
          bottom: "10%",
          containLabel: true
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985"
            }
          }
        },
        series: [
          {
            name: "全部",
            data: this.sentimentTrendData.charts_all,
            itemStyle: {
              normal: {
                color: "#4CB6FF",
                lineStyle: {
                  color: "#4CB6FF"
                }
              }
            },
            smooth: true,
            type: "line"
          }
        ]
      };
      myChart.setOption(option, true);
      setTimeout(() => {
        this.echartsDataUrl.url_trend_all = myChart.getDataURL({
          pixelRatio: 2,
          backgroundColor: "#fff"
        });
        this.isBtnDownloadDisabled_trend = false;
      }, 2000);
    },
    //生成折线图--来源分类
    generateCharts_line_source() {
      this.isBtnDownloadDisabled_trend = true;
      let myChart = this.echarts.init(this.$refs.charts_line_source);
      let option = {
        tooltip: {
          trigger: "axis"
        },
        legend: {
          data: this.sentimentTrendData.charts_source.data_legend, //所有来源的legend名称
          y: "380px"
        },
        title:{
          text:'舆情走势',
          textStyle:{
            fontWeight: 'normal',
            fontSize: 15
          }
        },
        grid: {
          top: "8%",
          left: "8%",
          right: "8%",
          bottom: "10%",
          containLabel: true
        },
        xAxis: {
          type: "category",
          data: this.sentimentTrendData.xData, //x轴数据
          // max:'dataMax',
          axisLabel:{
            showMinLagel:true,
            showMaxLabel: true,
            rotate: 45,
            interval: parseInt(this.sentimentTrendData.xData.length / 10)
          },
          axisTick:{
            alignWithLabel: true
          }
        },
        yAxis: {
          type: "value"
        },
        series: this.sentimentTrendData.charts_source.data_y
      };
      myChart.setOption(option, true);
      setTimeout(() => {
        this.echartsDataUrl.url_trend_source = myChart.getDataURL({
          pixelRatio: 2,
          backgroundColor: "#fff"
        });
        this.isBtnDownloadDisabled_trend = false;
      }, 2000);
    },
    generateCharts_line_emotions() {
      this.isBtnDownloadDisabled_trend = true;
      let myChart = this.echarts.init(this.$refs.charts_line_emotions);
      let option = {
        tooltip: {
          trigger: "axis"
        },
        legend: {
          data: this.sentimentTrendData.charts_emotion.data_legend, //所有来源的legend名称
          y: "380px"
        },
        title:{
          text:'舆情走势',
          textStyle:{
            fontWeight: 'normal',
            fontSize: 15
          }
        },
        grid: {
          top: "8%",
          left: "8%",
          right: "8%",
          bottom: "10%",
          containLabel: true
        },
        xAxis: {
          type: "category",
          data: this.sentimentTrendData.xData, //x轴数据
          // max:'dataMax',
          axisLabel:{
            showMinLagel:true,
            showMaxLabel: true,
            rotate: 45,
            interval: parseInt(this.sentimentTrendData.xData.length / 10)
          },
          axisTick:{
            alignWithLabel: true
          }
        },
        yAxis: {
          type: "value"
        },
        series: this.sentimentTrendData.charts_emotion.data_y
      };
      myChart.setOption(option, true);
      setTimeout(() => {
        this.echartsDataUrl.url_trend_emotions = myChart.getDataURL({
          pixelRatio: 2,
          backgroundColor: "#fff"
        });
        this.isBtnDownloadDisabled_trend = false;
      }, 2000);
    },
    getEventBaseInfo() {
       this.$ajax({
         method: "get",
         url: "./highlightEvent/getBaseInfo",
         params: {
           id : this.currentTaskId
         }
       })
      .then(res => {
        if (res.data.success) {
          this.eventBaseInfo = res.data.data;
        }
      })
      .catch(err => {
        console.log(err);
      })
    },
    generateCharts_bar(){
      let myChart = this.echarts.init(this.$refs.charts_bar);
      let option = {
        tooltip: {
          trigger: "item",
          formatter: "{b}: {c}"
        },
        grid: {
          left: "7%",
          right: "7%",
          bottom: "7%",
          top: "7%",
          containLabel: true
        },
        title:{
          text:'敏感分类',
          textStyle:{
            fontWeight: 'normal',
            fontSize: 15
          }
        },
        xAxis: {
          type: 'category',
          data: this.sensitiveTrendLabels
        },
        yAxis: {
          type: 'value',
          minInterval: 1,
        },
        series: [
          {
            data: this.sensitiveTrendData,
            type: 'bar'
          }
        ]
      }
      myChart.setOption(option, true);

    },
        //生成空心饼图
    generateCharts_circle() {
      let myChart = this.echarts.init(this.$refs.charts_circle);
      let option = {
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b}: {c} ({d}%)"
        },
        grid: {
          left: "7%",
          right: "7%",
          bottom: "7%",
          top: "7%",
          containLabel: true
        },
        title:{
          text:'情感分布',
          textStyle:{
            fontWeight: 'normal',
            fontSize: 15
          }
        },
        series: [
          {
            name: "情感分布",
            type: "pie",
            radius: ["50%", "65%"],
            label: {
              normal: {
                formatter: "{b}\n({d}%) ",
                textStyle: {
                  fontWeight: "normal",
                  fontSize: "15" //文字的字体大小
                }
              },
              emphasis: {
                show: true,
                textStyle: {
                  fontSize: "20",
                  fontWeight: "bold"
                }
              }
            },
            labelLine: {
              normal: {
                show: true
              }
            },
            data: this.emotionsDistrubutionData
          }
        ]
      };
      myChart.setOption(option, true);
      setTimeout(() => {
        this.echartsDataUrl.url_emotions = myChart.getDataURL({
          pixelRatio: 2,
          backgroundColor: "#fff"
        });
        //this.isBtnDownloadDisabled_emotions = false;
      }, 2000);
    },
    getSensitiveTrend(){
      this.$ajax({
        method: "get",
        url: "./highlightEvent/sensitiveTrend",
        params: {
          id: this.currentTaskId
        }
      }).then(res=>{
        if (res.data.success) {
          let resData = res.data.data || [];
          console.log(resData);
          this.sensitiveTrendData = [];
          this.sensitiveTrendLabels = [];
          resData.forEach(item=>{
            this.sensitiveTrendData.push(item.num);
            this.sensitiveTrendLabels.push(item.name);
          });
          console.log(this.sensitiveTrendData);
          this.generateCharts_bar();
        }
      }).catch(err => {
        this.$Message.error("服务器错误");
        console.log(err);
      });
    },
    //获取情感分布的数据
    getEmotionsDistributionInfo() {
      this.$ajax({
        method: "get",
        url: "./highlightEvent/feelingTrend",
        params: {
          id: this.currentTaskId
        }
      })
        .then(res => {
          //如果存在res.data
          if (res.data.success) {
            let resData = res.data.data;
            resData.emotions = resData.emotions || [];
            //先清空
            this.emotionsDistrubutionData = [];
            resData.emotions.forEach(item => {
              this.emotionsDistrubutionData.push({
                value: item.value,
                name: item.name,
                itemStyle: {
                  normal: {
                    color: (function(name) {
                      let color = "#44C58D";
                      switch (name) {
                        case "正面":
                          color = "#44C58D";
                          break;
                        case "负面":
                          color = "#FA5D5D";
                          break;
                        case "中性":
                          color = "#FFA810";
                          break;
                        default:
                          break;
                      }
                      return color;
                    })(item.name),
                    lineStyle: {
                      color: (function(name) {
                        let color = "#44C58D";
                        switch (name) {
                          case "正面":
                            color = "#44C58D";
                            break;
                          case "负面":
                            color = "#FA5D5D";
                            break;
                          case "中性":
                            color = "#FFA810";
                            break;
                          default:
                            break;
                        }
                        return color;
                      })(item.name)
                    }
                  }
                }
              });
            });
            //生成情感分布空心饼图
            this.generateCharts_circle();
          } else {
            if (res.data.code !== 405) {
              this.$Message.error("服务器错误");
            }
          }
        })
        .catch(err => {
          this.$Message.error("服务器错误");
          console.log(err);
        });
    },

    //生成词云
    generateCharts_wordCloud() {
      this.isBtnDownloadDisabled_wordCloud = true;
      let myChart = this.echarts.init(this.$refs.charts_wordCloud);
      let option = {
        tooltip: {
          show: true
        },
        grid: {
          x: 10,
          y: 10,
          x2: 10,
          y2: 10
        },
        title:{
          text:'词云分析',
          textStyle:{
            fontWeight: 'normal',
            fontSize: 15
          }
        },
        series: [
          {
            name: "词云分析",
            type: "wordCloud",
            size: ["95%", "95%"],
            rotationRange: [0, 0],
            sizeRange: [40, 80],
            textPadding: 0,
            autoSize: {
              enable: true,
              minSize: 14
            },
            data: this.wordCloudData
          }
        ]
      };

      myChart.setOption(option, true);
      setTimeout(() => {
        this.echartsDataUrl.url_wordCloud = myChart.getDataURL({
          pixelRatio: 2,
          backgroundColor: "#fff"
        });
        this.isBtnDownloadDisabled_wordCloud = false;
      }, 2000);
    },

    //获取词云分析数据
    getWordCloudInfo() {
      if (this.isLoadingWordCloud) return;
      this.isLoadingWordCloud = true;
      this.$ajax({
        method: "get",
        url: "./highlightEvent/wordCloud",
        params: {
          id: this.currentTaskId
        }
      })
        .then(res => {
          this.isLoadingWordCloud = false;
          if (res.data.success) {
            //先清空
            this.wordCloudData = [];
            let resData = res.data.data;
            resData.forEach(item => {
              this.wordCloudData.push({
                name: item.keyword,
                value: item.num,
                prop: item.feeling,
                textStyle: this.generateColor(parseInt(item.feeling))
              });
            });
            //生成词云图
            this.generateCharts_wordCloud();
          } else {
            if (res.data.code !== 405) {
              this.$Message.error("服务器错误");
            }
          }
        })
        .catch(err => {
          this.$Message.error("服务器错误");
          console.log(err);
        });
    },

    //根据词云的情感生成颜色
    generateColor(prop) {
      let obj = {
        normal: {
          color: ""
        }
      };
      switch (prop) {
        //正面
        case 2:
          obj.normal.color = "#44C58D";
          break;
        //中性
        case 0:
          obj.normal.color = "#FFA810";
          break;
        //负面
        case 1:
          obj.normal.color = "#FA5D5D";
          break;
        default:
          break;
      }
      return obj;
    },

    getGroupList() {
      this.$ajax({
        method: "get",
        url: "./highlightEvent/activeQunAndSender",
        params: {
          id: this.currentTaskId
        }
      })
      .then(res => {
        if (res.data.success) {
          if (res.data.data) {
            this.groupList = res.data.data.groupList
            this.userList = res.data.data.userList
          }
        }
      })
      .catch(err => {
        console.log(err)
      })
    },

    getFocusMsgList() {
      this.$ajax({
        method: "get",
        url: "./highlightEvent/eventAccess",
        params: {
          id: this.currentTaskId
        }
      })
      .then(res => {
        if (res.data.success) {
          if (res.data.data) {
             this.focusMsgList = res.data.data.focusMsgList
             this.accessMsgList = res.data.data.accessMsgList
             this.accessStartDate = res.data.data.accessStartDate
          }
        }
      })
      .catch(err => {
        console.log(err)
      })
    }
  }
}
</script>

<template>
  <div id="page-event">
    <div class="main">
      <header class="header">
        {{ this.eventBaseInfo.eventName }}
      </header>
      <div class="report-content">
        <div class="block-title">
          事件介绍
        </div>
        <div class="event-info">
          <div class="event-item">
            事件日期：{{ this.eventBaseInfo.timeDur }}
          </div>
          <div class="event-item">
            地点：{{ this.eventBaseInfo.address }}
          </div>
          <div class="event-item">
            预计人数：{{ this.eventBaseInfo.peopleNum }}
          </div>
        </div>
        <div class="event-content">
          {{ this.eventBaseInfo.detail }}
        </div>
        <div class="block-title">
          事件趋势
        </div>
        <div>
          <ul class="btnGroup">
            <li
                class="btnItem"
                :class="{'isSelected':btnTrendIsActive.all}"
                @click="handleSelectBtnTrend('all')"
            >全部</li>
            <li
                class="btnItem"
                :class="{'isSelected':btnTrendIsActive.source}"
                @click="handleSelectBtnTrend('source')"
            >来源分类</li>
            <li
                class="btnItem"
                :class="{'isSelected':btnTrendIsActive.emotions}"
                @click="handleSelectBtnTrend('emotions')"
            >情感分类</li>
          </ul>
          <div class="charts-wrapper">
            <div ref="charts_line_total" class="charts_line_total" v-show="btnTrendIsActive.all"></div>
            <div ref="charts_line_source" class="charts_line_source" v-show="btnTrendIsActive.source"></div>
            <div
                ref="charts_line_emotions"
                class="charts_line_emotions"
                v-show="btnTrendIsActive.emotions"
            ></div>
          </div>
        </div>
        <div class="block-title">
          数据类型
        </div>
        <div class="type-block">
          <Row :gutter="16">
            <Col span="12">
              <div class="charts-wrapper">
                <div ref="charts_circle" class="charts_circle"></div>
              </div>
            </Col>
            <Col span="12">
              <div class="charts-wrapper">
                <div ref="charts_bar" class="charts_bar"></div>
              </div>
            </Col>
          </Row>

        </div>
        <div class="block-title">
          热点词云
        </div>
        <div class="cloud-block">
          <div class="charts-wrapper">
            <div ref="charts_wordCloud" class="charts_wordCloud"></div>
          </div>
          <footer class="wordCloud-footer">
            <span class="wordCloud-legend legend-positive">正面</span>
            <span class="wordCloud-legend legend-middle">中性</span>
            <span class="wordCloud-legend legend-negative">负面</span>
          </footer>
        </div>
        <div class="block-title">
          活跃分析
        </div>
        <div style="padding: 10px 0">
          <Row :gutter="16">
            <Col span="12">
              <div>
                <Table border :columns="columnGroup" :data="groupList">
                </Table>
              </div>
            </Col>
            <Col span="12">
              <Table border :columns="columnUser" :data="userList">
              </Table>
            </Col>
          </Row>
        </div>
        <div class="block-title">
          重点关注消息
        </div>
        <div>
          <List v-for="(item, index) in focusMsgList" :key="item.id">
            <ListItem>
              <Row :gutter="16" style="width: 1000px;">
                <Col span="2">
                  <Tag color="error">负面</Tag>
                </Col>
                <Col span="18">
                  <div class="msg-row-cell-line msg-row-cell-user">
                    <div class="user-info">
                      <Icon type="ios-person-add" color="orange" size="24" v-if="item.senderFollwoed" style="cursor: pointer;" @click="cancelFollowSender(index, item.senderIdOri)"/>
                      <Icon type="ios-person-add-outline" color="orange" size="24" style="cursor: pointer;" v-else @click="followSender(index, item.senderIdOri)" />
                      {{ item.sendMsgName }}({{ item.senderId }})
                    </div>
                    <div class="user-info">
                      <Icon type="ios-people" color="orange" size="24" v-if="item.groupFollowed" style="cursor: pointer;" @click="cancelFollowQun(index, item.groupId)"/>
                      <Icon type="ios-people-outline" color="orange" size="24" style="cursor: pointer;" v-else @click="followQun(index, item.groupId)"/>
                      {{ item.groupName }}
                    </div>
                  </div>
                  <div class="msg-row-cell-line msg-row-cell-content">
                    {{ item.msg }}
                  </div>
                  <div class="msg-row-cell-line msg-row-cell-key">
                    <div class="key-info">
                      <span class="key-type">
                        关键词：
                      </span>
                      {{ item.eventKeyWord }}
                    </div>
                    <div class="key-info">
                      <span class="key-type">
                        敏感分类：
                      </span>
                      {{ item.eventTypeWord }}
                    </div>
                  </div>
                </Col>
                <Col span="4">
                  {{ item.publishDate }}
                </Col>
              </Row>
            </ListItem>
          </List>
        </div>
        <div class="block-title">
          传播途径
        </div>
        <div class="timeline">
          <Timeline>
            <TimelineItem color="green" class="timeline-item">
              <template #dot>
                <Icon type="ios-calendar-outline" size="36" color="orange"/>
              </template>
              <div class="time">{{ this.accessStartDate }}</div>
            </TimelineItem>

              <TimelineItem class="timeline-item"  v-for="item in accessMsgList" :key="item.id">
              <div class="time">
                {{ item.publishDate }}
                <span class="group-info">
                  {{ item.groupName }}
                </span>
                <span class="group-info">
                  {{ item.sendMsgName }}({{ item.senderId }})
                </span>
                <span class="group-info" style="color: red;" v-show="item.showFirstLabel == 0">
                  （可能是信息源头，仅供参考）
                </span>
              </div>
              <Tooltip max-width="900" :content="item.msg">
                <div class="content">
                  {{ item.msg }}
                </div>
              </Tooltip>
            </TimelineItem>

          </Timeline>
        </div>
      </div>
    </div>

  </div>
</template>

<style scoped lang="less">
#page-event {
  .main {
    width: 1160px;
    margin: 0 auto;
    margin-top: 20px;
    background-color: #fff;
    box-sizing: border-box;
    min-height: 1040px;
    padding: 0 80px;
    box-shadow: 0 0 16px 0 #f3f4f7;
    .header{
      height: 80px;
      box-sizing: border-box;
      padding-top: 20px;
      border-bottom: 1px solid #efeff4;
      font-size: 30px;
      line-height: 40px;
    }
    .report-content{
      padding-top: 20px;
      .block-title{
        border-bottom: 3px solid rgb(0,150,136);
        display: block;
        padding: 10px;
        font-size: 20px;
        font-weight: bold;
        width: 180px;
      }
      .event-info {
        display: block;
        text-align: left;
        .event-item{
          display: inline-block;
          padding: 25px 36px;
          font-size: 18px;
          color: darkred;
          font-weight: bold;
        }
      }
      .event-content{
        display: block;
        text-indent: 36px;
        font-size: 18px;
        text-align: left;
      }
      .btnGroup {
        margin-top: 26px;
        width: 240px;
        height: 22px;
        cursor: pointer;
        user-select: none;
        .btnItem {
          width: 80px;
          color: #415af6;
          font-family: PingFangSC-Regular;
          font-size: 14px;
          height: 22px;
          line-height: 22px;
          border: 1px solid #415af6;
          border-left: none;
          float: left;
          transition: all 0.2s ease-in-out;
          &:hover {
            opacity: 0.8;
          }
        }
        .btnItem:first-child {
          border-left: 1px solid #415af6;
          border-radius: 3px 0 0 3px;
        }
        .btnItem:last-child {
          border-radius: 0 3px 3px 0;
        }
        .isSelected {
          background-color: #415af6;
          color: #fff;
        }
      }
      .charts-wrapper {
        height: 400px;
        width: 100px;
        .charts_line_total,
        .charts_line_source,
        .charts_line_emotions {
          height: 400px;
          width: 1000px;
        }
      }
      .type-block{
        .charts-wrapper {
          .charts_circle {
            height: 400px;
            width: 500px;
          }
          .charts_bar{
            height: 400px;
            width: 500px;
          }
        }

      }
      .cloud-block{
        position: relative;
        height: 100%;
        width: 1000px;
        float: right;
        .charts-wrapper {
          height: 400px;
          width: 1000px;
          margin-left: 24px;
          .charts_wordCloud {
            height: 400px;
            width: 1000px;
          }

        }
        .wordCloud-footer {
          position: relative;
          bottom: 20px;
          height: 80px;
          width: 100%;
          display: flex;
          justify-content: center;
          .wordCloud-legend {
            font-family: PingFangSC-Regular;
            font-size: 12px;
            color: #666666;
            line-height: 80px;
          }
          .legend-positive {
            &::before {
              content: "";
              display: inline-block;
              height: 10px;
              width: 10px;
              border-radius: 50%;
              background-color: #44c58d;
              margin-right: 6px;
            }
          }
          .legend-middle {
            margin: 0 30px;
            &::before {
              content: "";
              display: inline-block;
              height: 10px;
              width: 10px;
              border-radius: 50%;
              background-color: #ffa810;
              margin-right: 6px;
            }
          }
          .legend-negative {
            &::before {
              content: "";
              display: inline-block;
              height: 10px;
              width: 10px;
              border-radius: 50%;
              background-color: #fa5d5d;
              margin-right: 6px;
            }
          }
        }
      }
      .msg-row-cell-line{
        display: block;
        text-align: left;
      }
      .msg-row-cell-content{
        margin: 10px 0;
      }
      .msg-row-cell-user{
        .user-info{
          display: inline-block;
          padding-right: 30px;
        }
      }
      .msg-row-cell-key{
        .key-info{
          display: inline-block;
          padding-right: 30px;
          .key-type{
            font-weight: bold;
          }
        }

      }
      .timeline{
        margin: 20px 0;
        .timeline-item{
          text-align: left;
          .time{
            font-size: 14px;
            font-weight: bold;
            .group-info{
              margin: 0 20px;
              font-weight: normal;
            }
          }
          .content{
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3;
            overflow: hidden;
            margin: 10px 0;
          }
        }
      }
    }
  }

}
</style>
